import React, { useEffect, useState } from 'react';
import {
  getGroups,
  addGroup,
  updateGroup,
  deleteGroup,
} from '../Service/apiService';
import toast, { Toaster } from 'react-hot-toast';

function GroupPage() {
  const [groups, setGroups] = useState([]);
  const [form, setForm] = useState({ groupName: '', description: '' });
  const [editId, setEditId] = useState(null);

  const loadGroups = async () => {
    try {
      const data = await getGroups();
      setGroups(data);
    //  toast.success('Groups loaded successfully');
    } catch (err) {
      console.error("Failed to load groups", err);
     // toast.error('Failed to load groups');
    }
  };

  useEffect(() => {
    loadGroups();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editId) {
        await updateGroup({ groupID: editId, ...form });
        toast.success('Group updated successfully');
      } else {
        await addGroup(form);
        toast.success('Group added successfully');
      }
      setForm({ groupName: '', description: '' });
      setEditId(null);
      loadGroups();
    } catch (err) {
      console.error("Error saving group", err);
      toast.error('Error saving group');
    }
  };

  const handleEdit = (group) => {
    setForm({ groupName: group.groupName, description: group.description });
    
    setEditId(group.groupID);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this group?")) {
      try {
        await deleteGroup(id);
      //  toast.success('Group deleted successfully');
        loadGroups();
      } catch (err) {
        console.error("Failed to delete group", err);
        toast.error('Failed to delete group');
      }
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-8">
      {/* Toaster container */}
      <Toaster position="top-right" />

      <h1 className="text-3xl font-bold mb-6">Groups</h1>

      <form onSubmit={handleSubmit} className="mb-8 flex flex-col space-y-4">
        <input
          type="text"
          placeholder="Group Name"
          value={form.groupName}
          onChange={(e) => setForm({ ...form, groupName: e.target.value })}
          required
          className="border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
        <input
          type="text"
          placeholder="Description"
          value={form.description}
          onChange={(e) => setForm({ ...form, description: e.target.value })}
          className="border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
        <div className="flex space-x-4">
          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
          >
  {editId != null ? "Update" : "Add"} Group
          </button>
          {editId && (
            <button
              type="button"
              onClick={() => {
                setForm({ groupName: '', description: '' });
                setEditId(null);
              }}
              className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400 transition"
            >
              Cancel
            </button>
          )}
        </div>
      </form>

      <ul className="space-y-4">
        {groups.map((group) => (
          <li
            key={group.groupID}
            className="flex justify-between items-center border p-4 rounded shadow-sm"
          >
            <div>
              <strong className="text-lg">{group.groupName}</strong>: {group.description}
            </div>
            <div className="space-x-2">
              <button
                onClick={() => handleEdit(group)}
                className="bg-yellow-400 text-white px-3 py-1 rounded hover:bg-yellow-500 transition"
              >
                Edit
              </button>
              <button
                onClick={() => handleDelete(group.groupID)}
                className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 transition"
              >
                Delete
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default GroupPage;
